import sdkConfig from "@/config/web.config";
import utils from "./utils";
// 事件文档地址：https://laientech.feishu.cn/wiki/JYecwOumGicuXAkBbi1ckNqxnuh?table=tblCijeuvU9hYInp&view=vewYFiABZx

let gtagReadyPromise;
// 动态插入 gtag.js 脚本，并初始化 gtag
function loadGtagScript() {
    if (gtagReadyPromise) return gtagReadyPromise;

    gtagReadyPromise = new Promise((resolve) => {
        if (window.gtag) {
            resolve(); // 已经存在，直接 resolve
            return;
        }

        if (document.getElementById("gtag-js")) {
            const checkReady = () => {
                if (window.gtag) resolve();
                else setTimeout(checkReady, 50);
            };
            checkReady();
            return;
        }

        const script = document.createElement("script");
        script.id = "gtag-js";
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${sdkConfig.ga4MeasurementID}`;
        script.onload = () => {
            window.dataLayer = window.dataLayer || [];
            function gtag() { dataLayer.push(arguments); }
            window.gtag = gtag;

            gtag('js', new Date());
            gtag('config', sdkConfig.ga4MeasurementID, {
                'debug_mode': sdkConfig.ga4DebugMode
            });
            gtag('config', sdkConfig.ga4AwID);


            resolve(); // 初始化完成
        };
        document.head.appendChild(script);
    });

    return gtagReadyPromise;
}


// 初始化gtag.js
loadGtagScript();
export async function setGtag(eventName, info = {}) {
    if (!utils.handlePidEvent('ga4')) return
    await loadGtagScript(); // 确保 gtag 已加载
    console.log(`${sdkConfig.ga4Name}${eventName}`, info);
    gtag('event', `${sdkConfig.ga4Name}${eventName}`, info);
}

export async function setGtagConversionEvent(info = {}) {
    if (!utils.handlePidEvent('ga4')) return
    await loadGtagScript(); // 确保 gtag 已加载
    gtag('event', 'conversion', info);
    console.log(info);

}
